import {
  IBuildingSchema as DEPRECATED__IBuildingSchema,
  IBusinessShoppingCenterSchema as DEPRECATED__IBusinessShoppingCenterSchema,
} from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { IOption, Option } from '../../../../models/Option';
import { IBuildingSchema } from '../../../../repositories/offer-card/entities/building/BuildingSchema';
import { IBusinessShoppingCenterSchema } from '../../../../repositories/offer-card/entities/business_shopping_center/BusinessShoppingCenterSchema';
import { getStatusType } from '../../../../utils/offer_helpers';
import { IOptionFacade } from '../../IOptionFacade';

export class StatusTypeOptionFacade implements IOptionFacade<string, string> {
  protected readonly building: IBuildingSchema | null;
  protected readonly businessShoppingCenter: IBusinessShoppingCenterSchema | null;

  public constructor(building: IBuildingSchema | null, businessShoppingCenter: IBusinessShoppingCenterSchema | null) {
    this.building = building;
    this.businessShoppingCenter = businessShoppingCenter;
  }

  public getOption(): IOption<string, string> | null {
    const value = this.value;

    if (!value) {
      return null;
    }

    return new Option(this.label, value, this.key);
  }

  protected get value(): string | null {
    const statusType = getStatusType(
      this.building as DEPRECATED__IBuildingSchema | null,
      this.businessShoppingCenter as DEPRECATED__IBusinessShoppingCenterSchema | null,
    );

    return statusType ?? null;
  }

  protected get label(): string {
    return 'Категория здания';
  }

  protected get key(): string {
    return 'statusType';
  }
}
